var text_email_did_text = '',
    text_email_did_status = true;

$(document).ready(function () {

    const siteLang = $('#siteLang').val();
    const unique_source_id = 38;

    $("#custom-phone").change(function () {
        $("#registrationform-phone").val($('.iti__selected-dial-code').text() + $(this).val())
    });

    if ($(window).width() >= 1024) {
        $('#start-trading-2').click(function () {
            const slide = $('#slide-2-2');
            slide.css('display', 'flex');
            slide.css('flex-direction', 'column');
            slide.css('align-items', 'center');
            slide.find('form').css('width', '100%')
        });
    }

    const formatState = function (state) {
        if (!state.id) {
            return state.text;
        }
        var stateline = $('<span class="fastbannerform-country flag-icon flag-icon-' + state.title + '"></span> <span class="fastbannerform-country">' + state.text + '</span>');
        return stateline;
    };

    $('.checkbox_container label').click(function () {
        if ($('#registrationform-iagree').is(':checked')) {
            $('.checkbox_container label').addClass('checkbox_container-checked');
        } else {
            $('.checkbox_container label').removeClass('checkbox_container-checked');
        }
    });


    $("select[data-type='select2']").select2({
        templateResult: formatState,
        templateSelection: formatState,
    });

    const formatState1 = function (state) {
        if (!state.id) {
            return state.text;
        }
        var stateline = $('<span style="width:0" class="fastbannerform-country flag-icon flag-icon-' + state.title + '"></span> <span class="fastbannerform-country">' + state.text + '</span>');
        return stateline;
    }
    $("select[data-type='select1']").select2({
        minimumResultsForSearch: -1,
        templateResult: formatState1,
        templateSelection: formatState1
    });

    $('input').on('focusin', function () {
        $(this).parent().find('label').addClass('active');
    });

    $('input').on('focusout', function () {
        if (!this.value) {
            $(this).parent().find('label').removeClass('active');
        }
    });


    $('.input-container').each(function () {
        let inputField = $(this).find('input');
        let inputLabel = $(this).find('label');

        $(this).prepend(inputField).prepend(inputLabel);
    });

    // $.ajax({
    //     url: '/trade-ifxbit/?account=80964640&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2NvdW50Ijo4MDk2NDY0MCwiZXhwIjoxNTk3MzI3MTU2LCJuYmYiOjE1OTcxNTQzNTYsIm9uY2UiOmZhbHNlLCJpYXQiOjE1OTcxNTQzNTZ9.6jmOgttO9mTAFIxeobl84YgHJpIUqe-nsX_Fus0MMXs',
    //     success: function(result){
    //
    //         console.log(result);
    //         const data = JSON.parse(result)
    //         if(data.url !== undefined) {
    //             $('#tradeIFXBIT').attr('href', data.url);
    //         }
    //     }
    // });

    const formAction = $form => {
        // let $form = $("#w0"), data = $form.data("yiiActiveForm");
        const formNumber = parseInt($($form).data('number'));

        const makeResByData = data => {
            const parsedData = JSON.parse(data);
            const resSuccess = $('.formResult');
            const resUnSuccess = $('.resUnSuccess');

            if (parsedData.login !== undefined) {

                resSuccess.find('td.login').text(parsedData.login);
                resSuccess.find('td.password').text(parsedData.password);
                resSuccess.find('td.account-type').text(parsedData.accountType);
                resSuccess.slideDown();

                const secureDeposit = $('#secureDeposit').attr('href');
                const splitedToken = parsedData.token.split('/');
                const dataToken = splitedToken[splitedToken.length - 1];

                if (splitedToken.find(el => el === 'token')) {
                    $('#secureDeposit').attr('href', secureDeposit +
                        '?token=' + dataToken);
                }

                if (parsedData.login !== undefined && parsedData.login != '') {
                    $.ajax({
                                url: siteLang + '/trade-ifxbit?account=' + parsedData.login + '&token=' + dataToken,
                        success: function (result) {
                            const data = JSON.parse(result)
                            if (data.url !== undefined) {
                                $('#tradeIFXBIT').attr('href', data.url);
                            }
                        }
                    });

                    parsedData['dataToken'] = dataToken;
                    const sendData = JSON.stringify(parsedData);

                    $.ajax({
                        url: siteLang + "/new-site/set-account-cookie?data=" + sendData,
                        method: 'POST',
                        success: function (result) {
                        }
                    });
                }

                //kadam
                $.each(kadam_list, function (k, v) {
                    if (v != '') {
                        try {
                            $.ajax({
                                url: "//postback.kadam.net/ru/postback/?data=" + v
                            })
                        } catch (e) {
                            console.log('Kadam subid sending error');
                        }
                    }
                })

                //event
                var image = new Image(),
                    keybut = 'open_account';

                image.crossOrigin = "Use-Credentials";
                image.src = "https://s.omsolution.net/omStatApi/analytics/q584.gif?referrer=" + escape(document.referrer) +
                    ((typeof (screen) == "undefined") ? "" : "&screen=" + screen.width + "*" + screen.height + "*" + (screen.colorDepth ? screen.colorDepth : screen.pixelDepth)) +
                    "&url=" + escape(document.URL) + "&event=" + keybut + "&" + Math.random();
            } else {
                if (parsedData.info.country) {
                    resUnSuccess.text(parsedData.info.country);
                    resUnSuccess.slideDown();
                } else {
                    resUnSuccess.text(parsedData.message);
                }
            }

        };

        const setCriteo = () => {
            $.ajax({
                url: siteLang + '/get-criteo-after',
                type: 'get',
                success: function (res) {
                    $('#criteo-after').html(res);
                }
            });
        }

        $form.on('beforeSubmit', function (e) {
            e.preventDefault();
            e.stopPropagation()

            emailSuggestion();

            if (text_email_did_status) {
                var data = $form.serialize();
                //Submit Form for
                $.ajax({
                    url: $form.attr('action'),
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    type: 'POST',
                    data: data,
                    beforeSend: function () {
                        $('.hideForRegLoader').show();
                    },
                    success: function (res) {
                        $('.formReg').slideDown().hide();
                        makeResByData(res);
                        setCriteo();
                    },
                    error: function (jqXHR, errMsg) {
                        alert(errMsg);
                    }
                });
            }

            return false; // prevent default submit
        });


        /**
         * Validate form on "registration-submit" button click
         */
        $(".registration-submit").eq(formNumber - 1).click(function () {
            $form.yiiActiveForm("validate");
            $.each(data.attributes, function () {
                this.status = 3;
            });
        });
    };

    formAction($("#w0"));
    formAction($("#w1"));
    formAction($("#w2"));

    $('body').on('click', '.mailcheck_replace', function () {
        var block = $(this);

        block.parents('form').find('input[id="registrationform-email"]').val(block.html());
        block.parents('.email__check__mean').html('');
        text_email_did_text = '';
        text_email_did_status = true;

        return false;
    });
});

function emailSuggestion() {
    var defaultDomains = ['msn.com', 'bellsouth.net',
        'telus.net', 'comcast.net', 'optusnet.com.au',
        'earthlink.net', 'qq.com', 'sky.com', 'icloud.com',
        'mac.com', 'sympatico.ca', 'googlemail.com',
        'att.net', 'xtra.co.nz', 'web.de',
        'cox.net', 'gmail.com', 'ymail.com',
        'aim.com', 'rogers.com', 'verizon.net',
        'rocketmail.com', 'google.com', 'optonline.net',
        'sbcglobal.net', 'aol.com', 'me.com', 'btinternet.com',
        'charter.net', 'shaw.ca'];

    var defaultSecondLevelDomains = ["yahoo", "hotmail", "mail", "live", "outlook", "gmx"];

    var defaultTopLevelDomains = ["com", "com.au", "com.tw", "ca", "co.nz", "co.uk", "de",
        "fr", "it", "ru", "net", "org", "edu", "gov", "jp", "nl", "kr", "se", "eu",
        "ie", "co.il", "us", "at", "be", "dk", "hk", "es", "gr", "ch", "no", "cz",
        "in", "net", "net.au", "info", "biz", "mil", "co.jp", "sg", "hu", "uk"];

    var block = $('input[id="registrationform-email"]');

    block.mailcheck({
        defaultDomains: defaultDomains,
        defaultSecondLevelDomains: defaultSecondLevelDomains,
        defaultTopLevelDomains: defaultTopLevelDomains,
        suggested: function (element, suggestion) {
            var suggestionFULL = text_email_did + ': <a href="#" class="mailcheck_replace">' + suggestion.full + '</a>?';
            block.parents('form').find('.email__check__mean').html(suggestionFULL);

            if (text_email_did_text == suggestion.full) {
                text_email_did_status = true;
            } else {
                text_email_did_text = suggestion.full;
                text_email_did_status = false;
            }
        },
        empty: function (element) {
            text_email_did_status = true;
            block.parents('form').find('.email__check__mean').html('');
        }
    });
}